import Lookup from './lookup.js';

export default class PlaceAffiliation extends Lookup
{
    
}
